module.exports = __webpack_public_path__ + "assets/img/logo.b4ad6125.png";